import React from "react";
import {Form,Col,Row, Container} from "react-bootstrap";
import {YesNoDrop,NumInput,CustomDrop,TextInput} from './dropdowns/components'
import {YesNoDropExtra,YesNoDropExtra4} from "./dropdowns/YesNoDropFamily"
class FamilyHistory extends React.Component{
    handleChange = (event) =>{
        this.props.handler('family_history',event);
    }
    render() {
      
        return(
            <Container style={{"maxWidth":"1600px"}}>
                <h3>Family History</h3><br/>
                <Form>
                    <Form.Row>
                        {/* <Form.Group as={Col}>
                            <Form.Label> Are parents related</Form.Label>
                            <Form.Control as={'select'} name={'parents_related'}onChange={this.handleChange}>
                                <option/>
                                <option>Yes</option>
                                <option>No</option>
                            </Form.Control>
                        </Form.Group> */}
                        <YesNoDrop title={"Are parents related"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"parents_related"} handler={this.handleChange}/>
                        {/* <Form.Group as={Col}>
                            <Form.Label> If yes are they first cousins?</Form.Label>
                            <Form.Control as={'select'} name={'parents_related_first_cousins'} onChange={this.handleChange}>
                                <option/>
                                <option>Yes</option>
                                <option>No</option>
                            </Form.Control>
                        </Form.Group> */}
                        <YesNoDrop title={"If yes are they first cousins"}  val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"parents_related_first_cousins"} handler={this.handleChange}/>
                        {/* <Form.Group as={Col}>
                            <Form.Label> If no, are they second cousins?</Form.Label>
                            <Form.Control as={'select'} name={'parents_related_first_cousins'}onChange={this.handleChange}>
                                <option/>
                                <option>Yes</option>
                                <option>No</option>
                            </Form.Control>
                        </Form.Group> */}
                        <YesNoDrop title={"If no are they second cousins"}  val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={"parents_related_first_cousins"} handler={this.handleChange}/>
                    </Form.Row>
                    
                    <Form.Row>
                        {/* <Col xs={4}>
                        <Form.Group>
                            <Form.Label column xs={50}> Is there a positive family history of Parkinson’s disease?</Form.Label>

                            <Form.Control as={'select'} name={'parkinson_family_history'} onChange={this.handleChange}>
                                <option/>
                                <option>Yes</option>
                                <option>No</option>
                            </Form.Control>
                        </Form.Group>
                        </Col> */}
                        <YesNoDropExtra title={"Is there a positive family history of Parkinson’s disease?"} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={'parkinson_family_history'} handler={this.handleChange}/>
                    </Form.Row>
                    <Form.Row>
                        {/* <Col xs={4}>
                        <Form.Group>
                            <Form.Label column> Is there a positive family history of tremor </Form.Label>
                            <Form.Control as={'select'} name={'tremor_family_history'} onChange={this.handleChange}>
                                <option/>
                                <option>Yes</option>
                                <option>No</option>
                            </Form.Control>
                        </Form.Group>
                       
                        </Col> */}
                        <YesNoDropExtra title={"Is there a positive family history of tremor "} val={this.props.data!=null? this.props.data:null}  disabled ={this.props.disabled} name={'tremor_family_history'} handler={this.handleChange}/>
                    </Form.Row>
                    <Form.Row>
                        {/* <Col xs={4}>
                        <Form.Group >
                            <Form.Label column> Is there a positive family history of dementia? </Form.Label>
                            <Form.Control as={'select'} name={'dementia_family_history'}onChange={this.handleChange}>
                                <option/>
                                <option>Yes</option>
                                <option>No</option>
                            </Form.Control>
                        </Form.Group>
                        </Col> */}
                        <YesNoDropExtra title={"Is there a positive family history of dementia? "} val={this.props.data!=null? this.props.data:null}  disabled ={this.props.disabled} name={'dementia_family_history'} handler={this.handleChange}/>
                    </Form.Row>
                    <Form.Row>
                        {/* <Form.Group as={Col}>
                            <Form.Label> Is there a positive family history of motor neuron disease </Form.Label>
                            <Form.Control as={'select'} name={'motor_neuron_family_history'}onChange={this.handleChange}>
                                <option/>
                                <option>Yes</option>
                                <option>No</option>
                            </Form.Control>
                        </Form.Group> */}
                        <YesNoDropExtra title={"Is there a positive family history of motor neuron disease "} val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled}   name={'motor_neuron_family_history'} handler={this.handleChange}/>
                    </Form.Row> 
                    <Form.Row>
                        {/* <Form.Group as={Col}>
                            <Form.Label> Is there a positive family history of PSP </Form.Label>
                            <Form.Control as={'select'} name={'psp_family_history'}onChange={this.handleChange}>
                                <option/>
                                <option>Yes</option>
                                <option>No</option>
                            </Form.Control>
                        </Form.Group> */}
                        <YesNoDropExtra title={"Is there a positive family history of PSP"}  val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={'psp_family_history'} handler={this.handleChange}/>
                    </Form.Row>
                    <Form.Row>
                        {/* <Form.Group as={Col}>
                            <Form.Label> Is there a positive family history of MSA </Form.Label>
                            <Form.Control as={'select'} name={'msa_family_history'}onChange={this.handleChange}>
                                <option/>
                                <option>Yes</option>
                                <option>No</option>
                            </Form.Control>
                        </Form.Group> */}
                        <YesNoDropExtra title={"Is there a positive family history of MSA"} val={this.props.data!=null? this.props.data:null}  disabled ={this.props.disabled} name={'msa_family_history'} handler={this.handleChange}/>
                    </Form.Row>
                    <Form.Row>
                        {/* <Form.Group as={Col}>
                        <Form.Label> Is there a positive family history of atypical parkinsonism (other) </Form.Label>
                        <Form.Control as={'select'} name={'atypical_parkinsonism'}onChange={this.handleChange}>
                            <option/>
                            <option>Yes</option>
                            <option>No</option>
                        </Form.Control>
                        </Form.Group> */}
                        <YesNoDropExtra title={"Is there a positive family history of atypical parkinsonism (other)"}   val={this.props.data!=null? this.props.data:null} disabled ={this.props.disabled} name={'atypical_parkinsonism_history'} handler={this.handleChange}/>
                        {/* <Form.Group as={Col}>
                            <Form.Label> Is there a positive family history of other neurological disease </Form.Label>
                            <Form.Control as={'select'} name={'other_neurological_disease'}onChange={this.handleChange}>
                                <option/>
                                <option>Yes</option>
                                <option>No</option>
                            </Form.Control>
                        </Form.Group> */}
                    </Form.Row>
                    <Form.Row>
                        <YesNoDropExtra4 title={"Is there a positive family history of other neurological disease"}   val={this.props.data!=null? this.props.data:null}  disabled ={this.props.disabled}  name={'other_neurological_disease_history'} handler={this.handleChange}/>
                    </Form.Row>
                </Form>

            </Container>
        )
    }
}
export default FamilyHistory;